import { Injectable } from '@angular/core';
import { CalculationBaseFormFactory } from '../../../base-form/form/base-form/calculation-base-form.factory';
import {RrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/rrsp.options";
import { FormFactory } from "@magieno/angular-advanced-forms";

@Injectable()
export class RrspFormFactory extends CalculationBaseFormFactory {

  constructor(protected override readonly formFactory: FormFactory) {
    super(formFactory);
    this.optionsType = RrspOptions;
  }
}
